import { render, staticRenderFns } from "./MCustomScrollbar.vue?vue&type=template&id=8990ddfe&scoped=true&"
import script from "./MCustomScrollbar.vue?vue&type=script&lang=js&"
export * from "./MCustomScrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8990ddfe",
  null
  
)

export default component.exports